<template>
  <div class="login-page">
    <!-- 顶部返回 -->
    <div class="back-btn" @click="goBack">
      <svg viewBox="0 0 24 24" class="back-icon">
        <path d="M15 18 L9 12 L15 6" fill="none" stroke="#323233" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>

    <!-- 顶部品牌区：logo + 名称 -->
    <div class="brand">
      <img src="@/assets/icons/login-logo.png" class="brand-logo" alt="logo" />
      <div class="brand-name">江苏智慧人社</div>
    </div>

    <!-- 登录方式切换 -->
    <div class="login-tabs">
      <div
        v-for="tab in tabs"
        :key="tab.key"
        :class="['tab-item', { active: activeTab === tab.key }]"
        @click="activeTab = tab.key"
      >
        <span class="tab-label">{{ tab.label }}</span>
        <span class="tab-line"></span>
      </div>
    </div>

    <!-- 账号登录 -->
    <div class="form-panel" v-if="activeTab === 'account'">
      <input
        v-model.trim="account"
        class="form-input"
        type="text"
        placeholder="请输入证件号/移动电话"
      />
      <div class="pwd-row">
        <input
          v-model.trim="password"
          class="form-input pwd-input"
          type="password"
          placeholder="请输入密码"
        />
        <span class="link-text" @click="onForgot">忘记密码?</span>
      </div>

      <!-- 协议勾选 -->
      <div class="agreement-row" @click="agreed = !agreed">
        <span :class="['checkbox', { checked: agreed }]">
          <svg v-if="agreed" viewBox="0 0 24 24" class="check-icon">
            <path d="M5 12.5 L10 17.5 L19 7" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
        <span class="agreement-text">
          我已阅读并同意<a class="link-text" @click.stop="onAgreement('用户协议')">《用户协议》</a>、<a class="link-text" @click.stop="onAgreement('隐私协议')">《隐私协议》</a>中的内容
        </span>
      </div>

      <!-- 登录/注册按钮 -->
      <div class="btn-primary" @click="doLogin">登录</div>
      <div class="btn-plain" @click="onRegister">注册</div>
    </div>

    <!-- 短信登录 -->
    <div class="form-panel" v-else>
      <input
        v-model.trim="smsPhone"
        class="form-input"
        type="text"
        placeholder="请输入手机号"
      />
      <div class="pwd-row">
        <input
          v-model.trim="smsCode"
          class="form-input pwd-input"
          type="text"
          placeholder="请输入验证码"
        />
        <span :class="['link-text', { disabled: countdown > 0 }]" @click="onSendCode">{{ countdown > 0 ? countdown + 's后重发' : '获取验证码' }}</span>
      </div>

      <div class="agreement-row" @click="agreed = !agreed">
        <span :class="['checkbox', { checked: agreed }]">
          <svg v-if="agreed" viewBox="0 0 24 24" class="check-icon">
            <path d="M5 12.5 L10 17.5 L19 7" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
        <span class="agreement-text">
          我已阅读并同意<a class="link-text" @click.stop="onAgreement('用户协议')">《用户协议》</a>、<a class="link-text" @click.stop="onAgreement('隐私协议')">《隐私协议》</a>中的内容
        </span>
      </div>

      <div class="btn-primary" @click="doSmsLogin">登录</div>
    </div>

    <!-- 其他方式登录 -->
    <div class="other-login">
      <div class="other-title">其他方式登录</div>
      <div class="other-icons">
        <img src="@/assets/icons/login-card.png" class="other-icon" alt="电子社保卡" @click="onOtherLogin('电子社保卡')" />
        <img src="@/assets/icons/login-csb.png" class="other-icon" alt="CSB" @click="onOtherLogin('CSB')" />
        <img src="@/assets/icons/login-alipay.png" class="other-icon" alt="支付宝" @click="onOtherLogin('支付宝')" />
      </div>
    </div>
  </div>
</template>

<script>
// 允许登录的演示账号
const VALID_ACCOUNT = '341122199210285619'
const VALID_PASSWORD = 'Qq+381162346'

export default {
  name: 'Login',
  data() {
    return {
      activeTab: 'account',
      tabs: [
        { key: 'account', label: '账号登录' },
        { key: 'sms', label: '短信登录' }
      ],
      account: '',
      password: '',
      smsPhone: '',
      smsCode: '',
      // 验证码60s倒计时
      countdown: 0,
      agreed: true
    }
  },
  beforeDestroy() {
    clearInterval(this._timer)
  },
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.replace('/mine')
      }
    },
    // 账号密码登录：仅指定账号可登录
    doLogin() {
      if (!this.agreed) {
        this.$alert('请先阅读并同意《用户协议》、《隐私协议》中的内容')
        return
      }
      if (!this.account || !this.password) {
        this.$alert('请输入证件号/移动电话和密码')
        return
      }
      if (this.account === VALID_ACCOUNT && this.password === VALID_PASSWORD) {
        localStorage.setItem('jszhrs_logged_in', '1')
        // 登录成功进入首页
        this.$router.replace('/home')
      } else {
        this.$alert('账号或密码错误')
      }
    },
    doSmsLogin() {
      if (!this.agreed) {
        this.$alert('请先阅读并同意《用户协议》、《隐私协议》中的内容')
        return
      }
      if (!/^1[3-9]\d{9}$/.test(this.smsPhone)) {
        this.$alert('请输入正确的手机号')
        return
      }
      if (!/^\d{6}$/.test(this.smsCode)) {
        this.$alert('请输入6位短信验证码')
        return
      }
      localStorage.setItem('jszhrs_logged_in', '1')
      this.$router.replace('/home')
    },
    onSendCode() {
      if (this.countdown > 0) return
      if (!/^1[3-9]\d{9}$/.test(this.smsPhone)) {
        this.$alert('请输入正确的手机号')
        return
      }
      this.$alert('验证码已发送（演示环境，任意6位数字均可作为验证码）')
      this.countdown = 60
      this._timer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) clearInterval(this._timer)
      }, 1000)
    },
    onForgot() {
      this.$router.push('/forgot-password')
    },
    // 登录页协议：跳转到协议文档页
    onAgreement(name) {
      this.$router.push(name === '用户协议' ? '/agreement-user' : '/privacy')
    },
    onRegister() {
      this.$router.push('/register')
    },
    onOtherLogin(name) {
      this.$alert(name + '登录暂未开通，请使用账号登录')
    }
  }
}
</script>

<style scoped>
.login-page {
  min-height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  /* 顶部淡绿landscape底色，模拟设计稿顶部浅色山水 */
  background: linear-gradient(180deg, #EAF5EF 0%, #F6FAF7 12%, #FFFFFF 26%);
}
.back-btn {
  position: absolute;
  left: calc(24 * var(--w));
  top: calc(56 * var(--w));
  width: calc(64 * var(--w));
  height: calc(64 * var(--w));
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.back-icon {
  width: calc(40 * var(--w));
  height: calc(40 * var(--w));
}

/* 品牌区 */
.brand {
  margin-top: calc(120 * var(--w));
  display: flex;
  flex-direction: column;
  align-items: center;
}
.brand-logo {
  width: calc(176 * var(--w));
  height: calc(176 * var(--w));
  /* 官方圆形徽章，只显示圆形（四角裁掉） */
  border-radius: 50%;
  object-fit: cover;
}
.brand-name {
  margin-top: calc(24 * var(--w));
  font-size: calc(44 * var(--w));
  color: #323233;
  font-weight: 500;
}

/* 登录方式切换 */
.login-tabs {
  margin-top: calc(80 * var(--w));
  display: flex;
  justify-content: center;
}
.tab-item {
  margin: 0 calc(60 * var(--w));
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}
.tab-label {
  font-size: calc(44 * var(--w));
  color: #323233;
  line-height: 1.4;
}
.tab-item.active .tab-label {
  color: #2D7DD2;
}
.tab-line {
  margin-top: calc(12 * var(--w));
  width: calc(64 * var(--w));
  height: calc(8 * var(--w));
  border-radius: calc(4 * var(--w));
  background: transparent;
}
.tab-item.active .tab-line {
  background: #2D7DD2;
}

/* 表单 */
.form-panel {
  padding: 0 calc(72 * var(--w));
}
/* 输入框：横线（下划线）样式 */
.form-input {
  margin-top: calc(48 * var(--w));
  width: 100%;
  height: calc(100 * var(--w));
  border: none;
  border-bottom: 1px solid #E3E5E8;
  border-radius: 0;
  background: transparent;
  padding: 0;
  font-size: calc(36 * var(--w));
  color: #323233;
  font-family: inherit;
  outline: none;
}
.form-input::placeholder {
  color: #C3C8CF;
}
.pwd-row {
  display: flex;
  /* 忘记密码与密码输入行上下居中 */
  align-items: center;
}
.pwd-input {
  flex: 1;
  min-width: 0;
}
.pwd-row .link-text {
  margin-left: calc(24 * var(--w));
  flex-shrink: 0;
}

/* 协议勾选 */
.agreement-row {
  margin-top: calc(40 * var(--w));
  display: flex;
  align-items: center;
  cursor: pointer;
}
.checkbox {
  width: calc(38 * var(--w));
  height: calc(38 * var(--w));
  border: 1px solid #C3C8CF;
  border-radius: calc(8 * var(--w));
  background: #fff;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.checkbox.checked {
  border-color: #2D7DD2;
  background: #2D7DD2;
}
.check-icon {
  width: calc(26 * var(--w));
  height: calc(26 * var(--w));
}
.agreement-text {
  margin-left: calc(16 * var(--w));
  font-size: calc(30 * var(--w));
  color: #646566;
  line-height: 1.4;
}

/* 链接文字 */
.link-text {
  font-size: calc(32 * var(--w));
  color: #2D7DD2;
  cursor: pointer;
}
.link-text.disabled {
  color: #9AA0A8;
  cursor: default;
}

/* 登录/注册按钮 */
.btn-primary {
  margin-top: calc(64 * var(--w));
  height: calc(120 * var(--w));
  border-radius: calc(12 * var(--w));
  background: #2D7DD2;
  color: #fff;
  font-size: calc(44 * var(--w));
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.btn-primary:active {
  background: #2569B4;
}
.btn-plain {
  margin-top: calc(40 * var(--w));
  height: calc(120 * var(--w));
  border-radius: calc(12 * var(--w));
  background: #fff;
  border: calc(2 * var(--w)) solid #2D7DD2;
  color: #2D7DD2;
  font-size: calc(44 * var(--w));
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.btn-plain:active {
  background: #F0F6FD;
}

/* 其他方式登录 */
.other-login {
  margin-top: auto;
  padding-bottom: calc(80 * var(--w));
  display: flex;
  flex-direction: column;
  align-items: center;
}
.other-title {
  font-size: calc(28 * var(--w));
  color: #9AA0A8;
}
.other-icons {
  margin-top: calc(40 * var(--w));
  display: flex;
  align-items: center;
}
.other-icon {
  width: calc(108 * var(--w));
  height: calc(108 * var(--w));
  margin: 0 calc(28 * var(--w));
  /* 三图标统一圆角方形尺寸，cover 保证视觉一致 */
  border-radius: calc(26 * var(--w));
  object-fit: cover;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue